import type Lenis from "lenis";

const NAVBAR_SELECTOR = "nav.navbar";

/** Moves keyboard / screen reader focus to the element without triggering a native scroll */
const focusWithoutScrolling = (element: HTMLElement) => {
  if (!element.hasAttribute("tabindex")) {
    element.setAttribute("tabindex", "-1");
  }
  element.focus({ preventScroll: true });
};

/**
 * Scrolls the element below the fixed navbar and moves focus to it.
 * Uses lenis when available, native scrolling doesn't work while lenis is animating
 * https://aleksundshantu.slack.com/archives/C08166QC5B2/p1734104421062139
 * Lenis itself jumps immediately when the user prefers reduced motion.
 */
export const scrollToElement = (element: HTMLElement, lenis?: Lenis) => {
  const navbarHeight =
    document.querySelector<HTMLElement>(NAVBAR_SELECTOR)?.offsetHeight ?? 0;

  if (lenis) {
    lenis.scrollTo(element, {
      offset: -navbarHeight,
      onComplete: () => focusWithoutScrolling(element),
    });
    return;
  }

  window.scrollTo({
    top: element.getBoundingClientRect().top + window.scrollY - navbarHeight,
  });
  focusWithoutScrolling(element);
};
